import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import './About.scss';
import Cover from '../Cover/Cover';
import MobileFooter from '../MobileFooter/MobileFooter';

const About = () => {
    const content = useSelector((state) => state.content.pages.about);
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);

    useEffect(() => {
        document.querySelector('#root').scrollTo(0, 0);
    }, []);

    if (typeof content !== 'undefined') {
        return (
            <div className={`about${isTouchScreen ? " touchscreen" : ""}`}>
                <Cover />
                <div className='about-content'>
                    <div className="about-section">
                        <div className="about-left">
                            <img
                                src={content.left_side.logo.url}
                                alt="Marlin Spring Logo"
                                className="about-logos"
                            />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: content.left_side.copy
                                }}
                            />
                        </div>
                    </div>
                    <div className="about-section">
                        <div className="about-right">
                            <img
                                src={content.right_side.logo.url}
                                alt="Greybrook Logo"
                                className="about-logos"
                            />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: content.right_side.copy
                                }}
                            />
                        </div>
                    </div>
                    <div className='about-line'></div>
                </div>
                <div className='deco-container'>
                    <img className='about-deco' src={content.left_side.decoration.url} />
                </div>
                <MobileFooter showBelow={1301} />
            </div>
        );
    } else {
        return <div></div>;
    }
};

export default About;
